import { z } from 'zod';
import { EntityUpdate } from './bullhornApiResponses.js';

export * as BullhornApiMeta from './bullhornApiMeta.js';
export * as BullhornApiResponses from './bullhornApiResponses.js';
export * as BullhornApiEntities from './bullhornApiEntities.js';
export {
  UnknownEntity as SomeBullhornEntity,
  type EntityName as BullhornEntityName,
  type EntityForName as BullhornEntityForName,
  BULLHORN_API_ENTITIES,
} from './bullhornApiEntities.js';
export { Field as BullhornApiField } from './bullhornApiMeta.js';

export const BullhornUpdateEntityResult = z.object({
  updateResult: EntityUpdate,
  associationResults: EntityUpdate.nullish().array(),
  updatedFieldCount: z.number(),
});
export type BullhornUpdateEntityResult = z.infer<typeof BullhornUpdateEntityResult>;
